<template>
  <ModalCustom v-model="isProvinceInactive" @close="close">
    <template #header>
      <p class="f-24 mb-2 font-weight-medium">
        {{ $t('modal.inactiveProvince.province') }} {{ provinceName }}
      </p>
      <p class="f-18 mb-2 font-weight-medium">
        {{ $t('modal.inactiveProvince.text1') }}
      </p>
      <p class="f-18 mb-2">
        {{ $t('modal.inactiveProvince.text2') }}
      </p>
      <p class="f-18 mb-0">
        {{ $t('modal.inactiveProvince.text3') }}
      </p>
    </template>
    <template #footer>
      <div class="d-flex flex-wrap justify-space-between align-center ga-3">
        <BaseButton :href="paymentFormLink" arrow>
          <span class="d-none d-md-inline">{{ $t('label.donateForSzp') }}</span>
          <span class="d-inline d-md-none">{{ $t('label.donateToHelp') }}</span>
        </BaseButton>
        <BaseButton variant="secondary" arrow @click="close">
          {{ $t('label.returnToProvinceList') }}
        </BaseButton>
      </div>
    </template>
  </ModalCustom>
</template>

<script setup>
import BaseButton from '@/components/widgets/BaseButton.vue'
import ModalCustom from '@/components/widgets/ModalCustom.vue'
import { LINKS } from '@/constants/externalLinks'
import { computed, nextTick, ref } from 'vue'
import { useGoTo } from 'vuetify'
const props = defineProps({
  province: {
    required: true,
    default: null
  }
})

const goTo = useGoTo()

const paymentFormLink = LINKS.szpPaymentFormInactiveProvince

const isProvinceInactive = ref(false)

const provinceName = computed(() => props.province?.province_name)

function open() {
  isProvinceInactive.value = true
}

async function close() {
  isProvinceInactive.value = false
  await nextTick()
  goTo('body', {
    easing: 'easeInQuad'
  })
}

defineExpose({
  open,
  close
})
</script>
